import { render, staticRenderFns } from "./documents-modal.vue?vue&type=template&id=54295add&"
import script from "./documents-modal.vue?vue&type=script&lang=js&"
export * from "./documents-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports